import { Box } from '@chakra-ui/react';
import React from 'react';
import { getEmptySections } from '../utils';
import { getLink, getSectionIndex, getUsefulVars } from '../../../handlers/helpers';

const EmptySections = ({ props }) => {
  const uv = getUsefulVars(props);
  const sections = getEmptySections(props);
  return (
    <Box >
      {Object.values(sections).map(([sectionName, sectionTitle]) => {
        const sectionIndex = getSectionIndex(uv.resume, sectionName);
        const link = getLink(false, uv.formikProps, uv.stateProps, sectionName, sectionIndex, 'section', sectionTitle);
        return (
          <Box className="emptySection" cursor='pointer'>{link}</Box>
        );
      })
      }
    </Box>
  );
};
export default EmptySections;